import { client } from "../client";

export const claimPrintJob = async ({
	clientId,
	jobKey,
}: {
	clientId: string;
	jobKey: string;
}) => {
	const response = await client.post<{ claimed: boolean }>("/print-jobs/claim", {
		clientId,
		jobKey,
	});

	return response.data.claimed;
};
